module.exports = __webpack_public_path__ + "assets/img/service-head.24fa9a36.png";